import { useAppDispatch } from '@/shared/lib/hooks/useAppDispatch';
import { useAppSelector } from '@/shared/lib/hooks/useAppSelector';
import { requestAndPollNutritionPlan } from '../model/nutritionSlice';

export const useNutritionPlan = () => {
    const dispatch = useAppDispatch();
    const { plan, loading, error } = useAppSelector((state) => state.nutrition);
    const instanceId = useAppSelector((state) => state.questionnaire.instanceId);

    const refetch = () => {
        if (instanceId) {
            dispatch(requestAndPollNutritionPlan(instanceId));
        }
    };

    return { plan, loading, error, refetch };
};
